import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import styled from 'styled-components';
import { createStyleFunction, getPropNamesFromPropDefinition, getPropFilter, isOverflowScrollable } from 'utils/ui';
import { sizePropsDef } from 'styles/styleProps/sizeProps';
import { marginPropsDef } from 'styles/styleProps/marginProps';
import { paddingPropsDef } from 'styles/styleProps/paddingProps';
import { themePropsDef } from 'styles/styleProps/themeProps';
import { borderPropsDef } from 'styles/styleProps/borderProps';
import { positionPropsDef } from 'styles/styleProps/positionProps';
import { displayPropsDef } from 'styles/styleProps/displayProps';
import { flexPropsDef, baseFlexRules } from 'styles/styleProps/flexProps';
import { textPropsDef } from 'styles/styleProps/textProps';
var propDefs = [].concat(_toConsumableArray(positionPropsDef), _toConsumableArray(displayPropsDef), _toConsumableArray(flexPropsDef), _toConsumableArray(sizePropsDef), _toConsumableArray(marginPropsDef), _toConsumableArray(paddingPropsDef), _toConsumableArray(themePropsDef), _toConsumableArray(borderPropsDef), _toConsumableArray(textPropsDef));
var styleProps = createStyleFunction(propDefs);
var shouldForwardProp = getPropFilter([].concat(_toConsumableArray(getPropNamesFromPropDefinition(propDefs)), ['animation']));
function isScrollable(_ref) {
  var overflow = _ref.overflow,
    overflowY = _ref.overflowY,
    overflowX = _ref.overflowX,
    theme = _ref.theme;
  return isOverflowScrollable(overflow, theme) || isOverflowScrollable(overflowX, theme) || isOverflowScrollable(overflowY, theme);
}
var Box = styled.div.attrs(function (props) {
  // Make sure that scrollable boxes are focusable
  if (isScrollable(props)) {
    return {
      tabIndex: 0
    };
  }
}).withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "Box",
  componentId: "sc-eallu3-0"
})(["", " ", ""], baseFlexRules, styleProps);
export default Box;